import React, { useState, useEffect } from "react";
import ReactDom from "react-dom";
import { useAppSelector } from "../../Redux/app/hooks";
import { buySellAmount, formatNumber } from "../../helpers/helper";
function FXBIOrderConfirmationDetail({
  confirm,
  primaryCurrecnyValue,
  secondaryCurrecnyValue,
  ask_value,
  bid_value,
  userType,
  selectedPortfolios,
  allocate_portfolio,
  custodianName,
  clientMarkupData,
}: any) {
  const form = useAppSelector((state) => state.orderSection.form_data);
  const totalEstMarkup = selectedPortfolios.reduce((sum: any, item: any) => sum + item.est_markup, 0);
  console.log("selectedPortfolios", selectedPortfolios);
  return (
    <>
      <div className="order-confirmation-table">
        <table>
          <thead className="thead-color">
            <tr key={"FXBO-001"}>
              {userType === "internal" && <th>Entity</th>}
              {userType !== "internal" && <th>Entity</th>}
              <th>Description</th>
              <th>Transaction</th>
              <th>Type</th>
              <th>Duration</th>
              {/* <th className="h-price-width">Price</th> */}
              <th>Price</th>
              {(userType === "internal" || userType === "internal_destributor") && <th>Est. Markup</th>}
              <th className="h-est-width">Est. Total</th>
            </tr>
          </thead>
          <tbody>
            <tr key={"FXBO-002"} className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row`}>
              {userType === "internal" && <td>{custodianName}</td>}
              {userType !== "internal" && <td>EMFI Capital</td>}
              <td>
                <span>{primaryCurrecnyValue}</span>
                <div className="tooltiptext">
                  <p>{primaryCurrecnyValue}</p>
                </div>
              </td>
              <td>{form.direction.toUpperCase()}</td>
              <td>{form.order_type === "stop_limit" ? "STOP LIMIT" : form.order_type.toUpperCase()}</td>
              <td>
                <span>{confirm.time.replace(/_/g, " ")}</span>
              </td>
              <td>
                {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "buy" ? (
                  <b>N/A</b>
                ) : (
                  <>{form.direction.toLowerCase() === "buy" && <b className="width-100">{Number(confirm.price).toFixed(5)}</b>}</>
                )}
              </td>
              {(userType === "internal" || userType === "internal_destributor") && (
                <td>
                  <b>0</b>
                </td>
              )}
              <td>
                {ask_value === 0 && form.order_type.toLowerCase() === "market" ? (
                  <b>N/A</b>
                ) : (
                  <>{<b className="width-100">{buySellAmount(formatNumber(confirm.quantity, 2), form.direction.toLowerCase())}</b>}</>
                )}
              </td>
            </tr>
            {/* second TR only Forex */}
            <tr key={"FXBO-003"} className={`${form.direction.toLowerCase() === "buy" ? "sell" : "buy"}-row divider-allocation`}>
              {userType === "internal" && <td>{custodianName}</td>}
              {userType !== "internal" && <td>EMFI Capital</td>}
              <td>{secondaryCurrecnyValue}</td>
              <td>{form.direction.toLowerCase() === "buy" ? "SELL" : "BUY"}</td>
              <td>{form.order_type === "stop_limit" ? "STOP LIMIT" : form.order_type.toUpperCase()}</td>
              <td>{confirm.time.replace(/_/g, " ")}</td>
              <td>
                {/* <b>1.09580</b> */}
                {ask_value === 0 && form.order_type.toLowerCase() === "market" ? (
                  <b>N/A</b>
                ) : (
                  <>{<b className="width-100">{Number(confirm.price).toFixed(5)}</b>}</>
                )}
              </td>
              {(userType === "internal" || userType === "internal_destributor") && (
                <td>
                  <b>0</b>
                </td>
              )}
              <td>
                {/* {form.order_type.toLowerCase() === "market" ? (
                  <>
                    {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.isInverse === false ? (
                      <b>N/A</b>
                    ) : (
                      <b>{buySellAmount(formatNumber(confirm.quantity), form.direction.toLowerCase() === "buy" ? "sell" : "buy")}</b>
                    )}
                  </>
                ) : (
                  <>
                    {
                      <b>
                        {buySellAmount(formatNumber(confirm.quantity * confirm.price, 2), form.direction.toLowerCase() === "buy" ? "sell" : "buy")}
                      </b>
                    }
                  </>
                )} */}
                <b className="width-100">{buySellAmount(formatNumber(form.quantity, 2), form.direction.toLowerCase() === "buy" ? "sell" : "buy")}</b>
              </td>
            </tr>
            {/* For client information */}
            {(userType === "internal") &&
              selectedPortfolios.map(
                (allocates_input: any, index: any) =>
                  allocates_input.client_id !== null &&
                  Number(allocates_input.client_id) !== 0 
                  && allocates_input.markup_value !== 0 
                  && allocates_input.markup_value !== null 
                  && allocates_input.markup_value !== undefined 
                  && (
                    <tr key={`EMFI-${allocates_input.client_id}`} className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row`}>
                      <td className={"td-text-indent"}>
                      {userType === "internal" &&
                        <>- {allocate_portfolio.filter((item: any) => item.id === allocates_input.client_id).map((item: any) => item.name)}</>
                        }
                        {userType === "internal_destributor" &&
                          <>- {allocate_portfolio.filter((item: any) => item.counterparty_id === allocates_input.client_id).map((item: any) => item.title)}</>
                        }
                      </td>
                      <td>{primaryCurrecnyValue}</td>
                        <td>{form.direction.toLowerCase() === "buy" ? "BUY" : "SELL"}</td>
                      <td>{form.order_type.toUpperCase()}</td>
                      <td>{confirm.time.replace(/_/g, " ")}</td>
                      <td>
                        {ask_value === 0 && form.order_type.toLowerCase() === "market" ? (
                          <b>N/A</b>
                        ) : (
                          // <>{<b>{Number(confirm.price).toFixed(5)}</b>}</>
                          <>{<b className="width-100">{Number(allocates_input.markup_price).toFixed(5)}</b>}</>
                        )}
                      </td>
                      {(userType === "internal" || userType === "internal_destributor") && (
                        <td>
                          <b>{allocates_input.est_markup}</b>
                        </td>
                      )}
                      <td>
                        {form.order_type.toLowerCase() === "market" ? (
                          <>
                            {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.isInverse === true ? (
                              <b>N/A</b>
                            ) : (
                              <b className="width-100">
                                {buySellAmount(
                                  formatNumber(allocates_input.inverse_convert_amt_display,2),
                                  form.direction.toLowerCase() === "buy" ? "buy" : "sell"
                                )}
                              </b>
                            )}
                          </>
                        ) : (
                          <>
                            {
                              <b>
                                {buySellAmount(
                                  formatNumber(allocates_input.inverse_convert_amt_display,2),
                                  form.direction.toLowerCase() === "buy" ? "buy" : "sell"
                                )}
                              </b>
                            }
                          </>
                        )}
                      </td>
                    </tr>
                  )
              )}
                  {/* Buy */}
          {userType === "internal_destributor"  &&
            selectedPortfolios.map(
              (allocates_input: any, index: any) =>
                allocates_input.client_id !== null &&
                Number(allocates_input.client_id) !== 0 
                && allocates_input.est_markup !== 0 
                && allocates_input.markup_value !== null 
                && allocates_input.markup_value !== undefined
                && (
                  <tr key={`EMFI-${allocates_input.client_id}`} className={`${form.direction.toLowerCase() === "buy" ? "buy" : "sell"}-row `}>
                    <td className={"td-text-indent"}>
                      - {allocate_portfolio.filter((item: any) => item.counterparty_id === allocates_input.client_id).map((item: any) => item.title)}
                    </td>
                    <td>{secondaryCurrecnyValue}</td>
                    <td>{form.direction.toLowerCase() === "buy" ? "BUY" : "SELL"}</td>
                    <td>{form.order_type.toUpperCase()}</td>
                    <td>{confirm.time.replace(/_/g, " ")}</td>
                    <td>
                      {ask_value === 0 && form.order_type.toLowerCase() === "market" ? (
                        <b>N/A</b>
                      ) : (
                        // <>{<b>{Number(confirm.price).toFixed(5)}</b>}</>
                        <>{<b className="width-100">{Number(allocates_input.markup_price).toFixed(5)}</b>}</>
                      )}
                    </td>
                   
                      {(userType === "internal" || userType === "internal_destributor") && (
                      <td>
                      <b>0</b>
                    </td>
                    )}
                  <td>   <b className="width-100">{buySellAmount(formatNumber(form.quantity, 2), form.direction.toLowerCase() === "buy" ? "buy" : "sell")}</b>
                  </td>
                  </tr>
                )
            )}
            {/* Sell */}
         {userType === "internal_destributor"  &&
            selectedPortfolios.map(
              (allocates_input: any, index: any) =>
                allocates_input.client_id !== null &&
                Number(allocates_input.client_id) !== 0 
                && allocates_input.est_markup !== 0 
                && allocates_input.markup_value !== null 
                && allocates_input.markup_value !== undefined
                && (
                  <tr key={`EMFI-${allocates_input.client_id}`} className={`${form.direction.toLowerCase() === "buy" ? "sell" : "buy"}-row `}>
                    <td className={"td-text-indent"}>
                      - {allocate_portfolio.filter((item: any) => item.counterparty_id === allocates_input.client_id).map((item: any) => item.title)}
                    </td>
                    <td>{primaryCurrecnyValue}</td>
                    <td>{form.direction.toLowerCase() === "buy" ? "SELL" : "BUY"}</td>
                    <td>{form.order_type.toUpperCase()}</td>
                    <td>{confirm.time.replace(/_/g, " ")}</td>
                    <td>
                      {ask_value === 0 && form.order_type.toLowerCase() === "market" ? (
                        <b>N/A</b>
                      ) : (
                        // <>{<b>{Number(confirm.price).toFixed(5)}</b>}</>
                        <>{<b className="width-100">{Number(allocates_input.markup_price).toFixed(5)}</b>}</>
                      )}
                    </td>
                    {(userType === "internal" || userType === "internal_destributor") && (
                      <td>
                        <b>{allocates_input.est_markup}</b>
                      </td>
                    )}
                     <td>
                      {form.order_type.toLowerCase() === "market" ? (
                        <>
                          {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.isInverse === false ? (
                            <b>N/A</b>
                          ) : (
                            <b className="width-100">
                              {buySellAmount(
                                new Intl.NumberFormat().format(allocates_input?.inverse_convert_amt_display),
                                form.direction.toLowerCase() === "buy" ? "buy" : "sell"
                              )}
                            </b>
                          )}
                        </>
                      ) : (
                        <>
                          {
                            <b className="width-100">
                              {buySellAmount(
                                new Intl.NumberFormat().format(allocates_input?.inverse_convert_amt_display),
                                form.direction.toLowerCase() === "buy" ? "buy" : "sell"
                              )}
                            </b>
                          }
                        </>
                      )}
                    </td>
                  </tr>
                )
            )}
          </tbody>
        </table>
        <>
          {ask_value === 0 && form.order_type.toLowerCase() === "market" && form.direction.toLowerCase() === "buy" ? (
            <></>
          ) : (
            <>
              {form.direction.toLowerCase() === "buy" && userType === "internal" && (
                <p>
                  At an exchange rate {confirm.price !== 0 ? Number(confirm.price).toFixed(5) : ""} of {primaryCurrecnyValue} to{" "}
                  {secondaryCurrecnyValue} estimated receivable {primaryCurrecnyValue} {formatNumber(confirm.quantity)} against{" "}
                  {secondaryCurrecnyValue} {new Intl.NumberFormat().format(confirm.quantity * confirm.price)}
                  {""} (Total Est. Markup : {primaryCurrecnyValue} {totalEstMarkup})
                </p>
              )}
              {form.direction.toLowerCase() === "buy" && userType !== "internal" && (
                <p>
                  At an exchange rate {confirm.price !== 0 ? Number(confirm.price).toFixed(5) : ""} of {primaryCurrecnyValue} to{" "}
                  {secondaryCurrecnyValue} estimated receivable {primaryCurrecnyValue} {formatNumber(confirm.quantity)} against{" "}
                  {secondaryCurrecnyValue} {new Intl.NumberFormat().format(confirm.quantity * confirm.price)}
                </p>
              )}
            </>
          )}
        </>
      </div>
    </>
  );
}

export default FXBIOrderConfirmationDetail;
